// curl 'https://ags.cuzk.cz/arcgis/rest/services/RUIAN/Prohlizeci_sluzba_nad_daty_RUIAN/MapServer/3?f=json' | jq '.fields[]'

/**
 * Typy stavebního objektu
 */
export enum TypStavebnihoObjektuKod {
  /**
   * Budova s číslem popisným
   */
  BudovaSCislemPopisnym = 1,
  /**
   * Budova s číslem evidenčním
   */
  BudovaSCislemEvidencnim = 2,
  /**
   * Budova bez č.p. i č.ev.
   */
  BudovaBezCPiCEv = 3,
}

/**
 * Způsoby využití stavebního objektu
 */
export enum ZpusobVyuzitiKod {
  /**
   * Průmyslový objekt
   */
  PrumyslovyObjekt = 1,
  /**
   * Zemědělská usedlost
   */
  ZemedelskaUsedlost = 2,
  /**
   * Objekt k bydlení
   */
  ObjektKBydleni = 3,
  /**
   * Objekt lesního hospodářství
   */
  ObjektLesnihoHospodarstvi = 4,
  /**
   * Objekt občanské vybavenosti
   */
  ObjektObcanskeVybavenosti = 5,
  /**
   * Bytový dům
   */
  BytovyDum = 6,
  /**
   * Rodinný dům
   */
  RodinnyDum = 7,
  /**
   * Stavba pro rodinnou rekreaci
   */
  StavbaProRodinnouRekreaci = 8,
  /**
   * Stavba pro shromažďování většího počtu osob
   */
  StavbaProShromazdovaniVetsihoPoctuOsob = 9,
  /**
   * Stavba pro obchod
   */
  StavbaProObchod = 10,
  /**
   * Stavba ubytovacího zařízení
   */
  StavbaUbytovacihoZarizeni = 11,
  /**
   * Stavba pro výrobu a skladování
   */
  StavbaProVyrobuaSkladovani = 12,
  /**
   * Zemědělská stavba
   */
  ZemedelskaStavba = 13,
  /**
   * Stavba pro administrativu
   */
  StavbaProAdministrativu = 14,
  /**
   * Stavba občanského vybavení
   */
  StavbaObcanskehoVybaveni = 15,
  /**
   * Stavba technického vybavení
   */
  StavbaTechnickehoVybaveni = 16,
  /**
   * Stavba pro dopravu
   */
  StavbaProDopravu = 17,
  /**
   * Garáž
   */
  Garaz = 18,
  /**
   * Jiná stavba
   */
  JinaStavba = 19,
  /**
   * Víceúčelová stavba
   */
  ViceucelovaStavba = 20,
  /**
   * Skleník
   */
  Sklenik = 21,
  /**
   * Přehrada
   */
  Prehrada = 22,
  /**
   * Hráz přehrazující vodní tok nebo údolí
   */
  HrazPrehrazujiciVodniTokNeboUdoli = 23,
  /**
   * Hráz k ochraně nemovitostí před zaplavením při povodni
   */
  HrazKOchraneNemovitostiPredZaplavenimPriPovodni = 24,
  /**
   * Hráz ohrazující umělou vodní nádrž
   */
  HrazOhrazujiciUmelouVodniNadrz = 25,
  /**
   * Jez
   */
  Jez = 26,
  /**
   * Stavba k plavebním účelům v korytech nebo na březích vodních toků
   */
  StavbaKPlavebnimUcelumVKorytechNeboNaBrezichVodnichToku = 27,
  /**
   * Stavba k využití vodní energie (vodní elektrárna)
   */
  StavbaKVyuzitiVodniEnergie = 28,
  /**
   * Stavba odkaliště
   */
  StavbaOdkaliste = 29,
  /**
   * Rozestavěné jednotky
   */
  RozestaveneJednotky = 30,
}

/**
 * Druhy svislé nosné konstrukce stavebního objektu
 */
export enum DruhKonstrukceKod {
  /**
   * Cihly, tvárnice, cihlové bloky
   */
  CihlyTvarniceCihloveBloky = 1,
  /**
   * Kámen
   */
  Kamen = 2,
  /**
   * Kámen a cihly
   */
  KamenACihly = 3,
  /**
   * Stěnové panely
   */
  StenovePanely = 4,
  /**
   * Nepálené cihly
   */
  NepaleneCihly = 5,
  /**
   * Dřevo
   */
  Drevo = 6,
  /**
   * Jiné materiály a kombinace
   */
  JineMaterialyAKombinace = 7,
  /**
   * Nedefinováno
   */
  Nedefinovano = 8,
  /**
   * Nezjištěno
   */
  Nezjisteno = 9,
  /**
   * Kámen, cihly, tvárnice včetně kombinací
   */
  KamenCihlyTvarniceVcetneKombinaci = 10,
  /**
   * Monolit
   */
  Monolit = 11,
}

/**
 * Připojení stavebního objektu ke kanalizaci
 */
export enum PripojeniKanalizaceKod {
  /**
   * Připojení na kanalizační síť
   */
  PripojeniNaKanalizacniSit = 1,
  /**
   * Vlastní čistička odpadních vod
   */
  VlastniCistickaOdpadnichVod = 2,
  /**
   * Žumpa, jímka
   */
  ZumpaJimka = 3,
  /**
   * Bez kanalizace a jímky
   */
  BezKanalizaceAJimky = 4,
  /**
   * Nedefinováno
   */
  Nedefinovano = 8,
  /**
   * Nezjištěno
   */
  Nezjisteno = 9,
}

/**
 * Připojení stavebního objektu k rozvodu plynu
 */
export enum PripojeniPlynKod {
  /**
   * Plyn z veřejné sítě
   */
  PlynZVerejneSite = 1,
  /**
   * Plyn z domovního zásobníku
   */
  PlynZDomovnihoZasobniku = 2,
  /**
   * Bez plynu
   */
  BezPlynu = 3,
  /**
   * Nedefinováno
   */
  Nedefinovano = 8,
  /**
   * Nezjištěno
   */
  Nezjisteno = 9,
  /**
   * Plyn v domě
   */
  PlynVDome = 51,
}

/**
 * Připojení stavebního objektu k vodovodu
 */
export enum PripojeniVodovodKod {
  /**
   * S vodovodem
   */
  SVodovodem = 1,
  /**
   * Bez vodovodu
   */
  BezVodovodu = 2,
  /**
   * Nezjištěno
   */
  Nezjisteno = 9,
}

/**
 * Způsoby vytápění stavebního objektu"
 */
export enum ZpusobVytapeniKod {
  /**
   * Centrální domovní (kotel ve stavbě)
   */
  CentralniDomovni = 1,
  /**
   * Centrální dálkové (kotel mimo stavbu)
   */
  CentralniDalkove = 2,
  /**
   * Lokální (kotel nebo jiné topidlo v bytě)
   */
  Lokalni = 3,
  /**
   * Jiné (i bez topení)
   */
  Jine = 4,
  /**
   * Nezjištěno
   */
  Nezjisteno = 9,
}

/**
 * Vybavení stavebního objektu výtahem
 */
export enum VybaveniVytahemKod {
  /**
   * S výtahem
   */
  SVytahem = 1,
  /**
   * Bez výtahu
   */
  BezVytahu = 2,
  /**
   * Nezjištěno
   */
  Nezjisteno = 9,
}

/**
 * Zdroj geometrie
 */
export enum ZdrojGeometrie {
  /**
   * DKM
   */
  DKM = 1,
  /**
   * UKM
   */
  UKM = 2,
}

export interface RuianStavebniObjekt {
  objectid: number
  kod: number
  nespravny: string
  cisladomovni: string
  identifikacniparcela: string
  typstavebnihoobjektukod: TypStavebnihoObjektuKod
  zpusobvyuzitikod: ZpusobVyuzitiKod
  castobce: string
  momc: string
  platiod: string
  platido: string
  idtransakce: string
  globalniidnavrhuzmeny: string
  isknbudovaid: string
  dokonceni: string
  druhkonstrukcekod: DruhKonstrukceKod
  obestavenyprostor: number
  pocetbytu: number
  pocetpodlazi: number
  podlahovaplocha: number
  pripojenikanalizacekod: PripojeniKanalizaceKod
  pripojeniplynkod: PripojeniPlynKod
  pripojenivodovodkod: PripojeniVodovodKod
  vybavenivytahemkod: VybaveniVytahemKod
  zastavenaplocha: number
  zpusobvytapenikod: ZpusobVytapeniKod
  zdorj: ZdrojGeometrie
}
